import { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  MachineCardImg,
  MachineBuyCard,
  MachineBuyCardContainer,
  MachineValueText,
} from "./Investment.styled";

const MachineBuy = (props) => {
  const { showMachineBuy, setShowMachineBuy, selectedMachine } = props;
  const navigate = useNavigate();
  const [qty, setQty] = useState(0);
  return (
    <MachineBuyCardContainer
      style={{ display: `${showMachineBuy ? "flex" : "none"}` }}
    >
      <MachineBuyCard>
        <div
          style={{ marginInline: "auto 15px", cursor: "pointer" }}
          onClick={() => {
            setShowMachineBuy(false);
            setQty(0);
          }}
        >
          X
        </div>
        <div style={{ display: "flex", justifyContent: "space-evenly" }}>
          <div>
            <MachineCardImg alt="machine1" src={selectedMachine.image} />
            <MachineValueText>
              Revenue{" "}
              <span style={{ marginBottom: "5px" }}>
                {selectedMachine.daily_profit} TRX
              </span>
            </MachineValueText>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            <div>
              <div>{selectedMachine.name}</div>
              <MachineValueText style={{ marginBottom: "5px" }}>
                {selectedMachine.price} TRX
              </MachineValueText>
            </div>
            <div>
              <div>1 year profit</div>
              <MachineValueText style={{ marginBottom: "5px" }}>
                {(selectedMachine.daily_profit * 365).toFixed(2)} TRX
              </MachineValueText>
            </div>
            <div>
              <div>30 days profit</div>
              <MachineValueText style={{ marginBottom: "5px" }}>
                {(selectedMachine.daily_profit * 30).toFixed(2)} TRX
              </MachineValueText>
            </div>
            <div>
              <div>Earning cycle</div>
              <MachineValueText style={{ marginBottom: "5px" }}>
                {selectedMachine.earning_sequence} hour
              </MachineValueText>
            </div>
          </div>
        </div>
        <div style={{ display: "flex", alignItems: "center", margin: "20px" }}>
          <div style={{ display: "flex", alignItems: "center" }}>
            QTY:{" "}
            <input
              style={{
                borderRadius: 0,
                border: "1px solid grey",
                height: "30px",
                width: "20%",
                marginInlineStart: "5px",
              }}
              value={qty}
              readOnly
            />
            <button
              style={{
                borderRadius: 0,
                height: "40px",
                width: "40px",
                marginInline: "7px",
              }}
              onClick={() => setQty(qty - 1)}
              disabled={qty === 0 && true}
            >
              -
            </button>
            <button
              style={{ borderRadius: 0, height: "40px", width: "40px" }}
              onClick={() => setQty(qty + 1)}
              disabled={qty === selectedMachine.max_quantity && true}
            >
              +
            </button>
          </div>
          <button
            style={{ marginLeft: "auto", height: "40px", width: "40%" }}
            onClick={() => {
              navigate("/buy-miner", { state: { selectedMachine, qty } });
            }}
            disabled={qty === 0 && true}
          >
            Buy
          </button>
        </div>
      </MachineBuyCard>
    </MachineBuyCardContainer>
  );
};

export default MachineBuy;
